import axios from "./axios"
import { server, feedback } from "./constants"

/**
 * Get feedbacks from the server
 */
const getFeedbacks = async (isAdmin = undefined) => {
  let accessToken = localStorage.getItem(server.ACCESS_TOKEN)
  const { data, status } = await axios.get(feedback.FEEDBACKS_URL, {
    params: { admin: isAdmin },
    headers: { Authorization: `be ${accessToken}` },
  })
  if (status === 200) {
    return data
  }
  throw new Error("Failed to get feedbacks")
}

/**
 * Send feedback to the server
 */
const sendFeedback = async message => {
  let accessToken = localStorage.getItem(server.ACCESS_TOKEN)
  const { data, status } = await axios.post(
    feedback.FEEDBACK_URL,
    { message },
    { headers: { Authorization: `be ${accessToken}` } }
  )
  if (status === 200 && data.success) {
    return data
  }
  throw new Error("Failed to send feedback")
}

/**
 * Pin feedback to the server
 */
const pinFeedback = async (id, isPin) => {
  let accessToken = localStorage.getItem(server.ACCESS_TOKEN)
  const { data, status } = await axios.put(
    `${feedback.FEEDBACK_URL}/${id}`,
    {
      isPin,
    },
    {
      params: { admin: true },
      headers: { Authorization: `be ${accessToken}` },
    }
  )
  return data
}

/**
 * Like feedback to the server
 */
const likeFeedback = async (id, isLike) => {
  const { data, status } = await axios.put(`${feedback.FEEDBACK_URL}/${id}`, {
    isLike,
  })
  return data
}

export default {
  getFeedbacks,
  sendFeedback,
  pinFeedback,
  likeFeedback,
}
